export const enUS = {
    "#FilteredItemsOf#": "# Filtered Items of #",
    "#MinutesAgo": "# minutes ago",
    "aBranchWithTheName#branchName#AlreadyExists": "A branch with the name #branchName# already exists",
    "accept": "Accept",
    "access": "Access",
    "accessControlTable": "Access Control Table (TCA)",
    "accessibility": "Accessibility",
    "accessType": "Access Type",
    "aConsecutiveWithTheCode'#numerodecódigo#'AlreadyExists.": "A consecutive with the code '#numerodecódigo#' already exists.",
    "actingAsARepresentative": "Acting as a representative?",
    "activateBranches": "Activate branch(es)",
    "activateProfiles": "Activate profile(s)",
    "active_Female": "Active",
    "active_Male": "Active",
    "activeInTheElectronicOffice": "Active in the electronic office",
    "activeTRD": "Active TRD",
    "actsAsARepresentative": "Acts as a representative?",
    "actuaComoRepresentanteQuestion": "Acting as a representative?",
    "add": "Add",
    "addANewKeyword": "Add a new keyword",
    "addAttachmentType": "Add attachment type",
    "addDocumentType": "Add document type",
    "addExternalCopy": "Add external copy",
    "addFolder": "Add folder",
    "additionalInformation": "Additional information",
    "addKeyword": "Add keyword",
    "addLocation": "Add location",
    "address": "Address",
    "addressRequired": "Address required",
    "aDefinitiveAnswerHasBeenGivenWithThePhysicalOutgoingRecordNo.#RecordNumber#": "A definitive answer has been given with the physical outgoing record No. #RecordNumber#",
    "administration": "Administration",
    "administrativeClosure": "Administrative closure",
    "administrativeClosureOfTheRecordCompleted": "Administrative closure of the record completed",
    "administrativeClosureSuccessfullyCompleted": "Administrative closure successfully completed",
    "advancedOrientationSearch": "Advanced orientation search",
    "advancedSearch": "Advanced search",
    "advancedSearchForRecordsAndInternalCommunications": "Advanced search for records and internal communications",
    "ageRange": "Age range",
    "ageRanges": "Age ranges",
    "aHolidayWithTheDate#Date#AlreadyExists": "A holiday with the date #Date# already exists",
    "alertCreatedSuccessfully": "Alert created successfully",
    "alerts": "Alerts",
    "all": "All",
    "allowedExtensions": "Allowed extensions",
    "allowEditing": "Allow editing",
    "allowReassignment": "Allow reassignment",
    "allowReturn": "Allow return",
    "allSections": "All sections",
    "allTaskTypes": "All task types",
    "aNewVersionOfTheApplicationHasBeenDownloaded,SoThePageWillBeUpdated.IfThisMessagePersists,PressTheCtrl+F5Key": "A new version of the application has been downloaded, so the page will be updated. If this message persists, press Ctrl + F5",
    "annotations": "Annotations",
    "anonymous": "Anonymous",
    "anonymousFiling": "Anonymous filing",
    "aParameterWithTheName'#nombre#'AlreadyExistsInTheGroup'#grupo#'": "A parameter with the name '#nombre#' already exists in the group '#grupo#'",
    "applications": "Applications",
    "approval": "Approval",
    "approvalComments": "Approval comments",
    "approvalDenied": "Approval denied",
    "approvalOfFileTransferByDepartment": "Approval of file transfer by department",
    "approvalOfIncomingMail-DocumentFlow": "Approval of incoming mail - Document flow",
    "approvalOfRecordTransfer": "Approval of record transfer",
    "approvalPending": "Approval pending",
    "approvalRequest": "Approval request",
    "approvalRequestSentSuccessfully": "Approval request sent successfully",
    "approve": "Approve",
    "approved": "Approved",
    "approveFinalStepOfOutgoingMailDocumentFlow": "Approve final step of outgoing mail document flow",
    "approveInternalCommunication": "Approve internal communication",
    "approveOutgoingMail": "Approve outgoing mail",
    "approveOutgoingMailWithDigitalSignature": "Approve outgoing mail with digital signature",
    "approveOutgoingPQR": "Approve outgoing PQR",
    "approvePostponingTransfers": "Approve postponing transfers",
    "approver": "Approver",
    "approverUser": "Approver user",
    "approverUserSubsection": "Approver user subsection",
    "approverUserUpdatedSuccessfully": "Approver user updated successfully",
    "approveStepInOutgoingMailDocumentFlow": "Approve step in outgoing mail document flow",
    "approveTransfers": "Approve transfers",
    "archive": "Archive",
    "archiveIncomingFile": "Archive incoming file",
    "archivoX_EditNotification": "Edit notification",
    "areaCode": "Area code",
    "areaManager": "Area manager",
    "areYouSureYouWantToActivateTheSelectedBranch(es)": "Are you sure you want to activate the selected branch(es)?",
    "areYouSureYouWantToActivateTheSelectedProfile(s)": "Are you sure you want to activate the selected profile(s)?",
    "areYouSureYouWantToApproveForTheCurrentOutgoingFile": "Are you sure you want to approve for the current outgoing file?",
    "areYouSureYouWantToApproveTheCurrentInternalCommunication": "Are you sure you want to approve the current internal communication?",
    "areYouSureYouWantToArchiveTheIncomingFile": "Are you sure you want to archive the incoming file?",
    "areYouSureYouWantToAssociateTheUserWithTheSection": "Are you sure you want to associate the user with the section?",
    "areYouSureYouWantToBreakInheritanceOfRecordPermissions": "Are you sure you want to break inheritance of record permissions?",
    "areYouSureYouWantToBreakThePermissionInheritanceOfTheDocument": "Are you sure you want to break the permission inheritance of the document?",
    "areYouSureYouWantToChangeTheRecordResponsible": "Are you sure you want to change the record responsible?",
    "areYouSureYouWantToCompleteTheShippingAssignment": "Are you sure you want to complete the shipping assignment?",
    "areYouSureYouWantToCreateTheCity": "Are you sure you want to create the city?",
    "areYouSureYouWantToCreateTheCountry": "Are you sure you want to create the country?",
    "areYouSureYouWantToCreateTheDecision": "Are you sure you want to create the decision?",
    "areYouSureYouWantToCreateTheExpedient": "Are you sure you want to create the expedient?",
    "areYouSureYouWantToCreateTheExtension": "Are you sure you want to create the extension?",
    "areYouSureYouWantToCreateTheFolder": "Are you sure you want to create the folder?",
    "areYouSureYouWantToCreateTheFund": "Are you sure you want to create the fund?",
    "areYouSureYouWantToCreateTheProfile": "Are you sure you want to create the profile?",
    "areYouSureYouWantToCreateTheRecord": "Are you sure you want to create the record?",
    "areYouSureYouWantToCreateTheRecordAssociation": "Are you sure you want to create the record association?",
    "areYouSureYouWantToCreateTheRole": "Are you sure you want to create the role?",
    "areYouSureYouWantToCreateTheSection": "Are you sure you want to create the section?",
    "areYouSureYouWantToCreateTheSeries": "Are you sure you want to create the series?",
    "areYouSureYouWantToCreateTheShippingMethod": "Are you sure you want to create the shipping method?",
    "areYouSureYouWantToCreateTheSubseries": "Are you sure you want to create the subseries?",
    "areYouSureYouWantToCreateTheVersion": "Are you sure you want to create the version?",
    "areYouSureYouWantToDeactivateTheSelectedBranch(es)": "Are you sure you want to deactivate the selected branch(es)?",
    "areYouSureYouWantToDeactivateTheSelectedProfile(s)": "Are you sure you want to deactivate the selected profile(s)?",
    "areYouSureYouWantToDeleteFileReferencenumber": "Are you sure you want to delete the file with reference number?",
    "areYouSureYouWantToDeleteTheAssociatedProperty": "Are you sure you want to delete the associated property?",
    "areYouSureYouWantToDeleteTheAssociation": "Are you sure you want to delete the association?",
    "areYouSureYouWantToDeleteTheCommunication?AllRelatedInformationWillBeDeleted": "Are you sure you want to delete the communication? All related information will be deleted.",
    "areYouSureYouWantToDeleteTheDocument": "Are you sure you want to delete the document?",
    "areYouSureYouWantToDeleteTheDocumentTypeAssociation": "Are you sure you want to delete the document type association?",
    "areYouSureYouWantToDeleteTheEntityType": "Are you sure you want to delete the entity type?",
    "areYouSureYouWantToDeleteTheFolderAssociation": "Are you sure you want to delete the folder association?",
    "areYouSureYouWantToDeleteTheLink": "Are you sure you want to delete the link?",
    "areYouSureYouWantToDeleteTheParameter": "Are you sure you want to delete the parameter?",
    "areYouSureYouWantToDeleteThePermission": "Are you sure you want to delete the permission?",
    "areYouSureYouWantToDeleteThePhysicalLocation": "Are you sure you want to delete the physical location?",
    "areYouSureYouWantToDeleteTheRecord": "Are you sure you want to delete the record?",
    "areYouSureYouWantToDeleteTheSelectedAlert": "Are you sure you want to delete the selected alert?",
    "areYouSureYouWantToDeleteTheSelectedFolder": "Are you sure you want to delete the selected folder?",
    "areYouSureYouWantToDeleteTheSelectedItem": "Are you sure you want to delete the selected item?",
    "areYouSureYouWantToDeleteTheSelectedRecord": "Are you sure you want to delete the selected record?",
    "areYouSureYouWantToDeleteTheUser'#login#": "Are you sure you want to delete the user '#login#?",
    "areYouSureYouWantToLinkTheRequest?OnceTheActionIsPerformed,ItCannotBeUndone": "Are you sure you want to link the request? Once the action is performed, it cannot be undone.",
    "areYouSureYouWantToLinkTheRequestsToTheEnteredIncomingFile?PleaseNoteThatThisProcessCannotBeReversed": "Are you sure you want to link the requests to the entered incoming file? Please note that this process cannot be reversed.",
    "areYouSureYouWantToMarkTheCommunicationAsRead": "Are you sure you want to mark the communication as read?",
    "areYouSureYouWantToMoveTheDocumentToRecordNo.#RecordNumber#WithThe'radicado'DocumentType": "Are you sure you want to move the document to record No. #RecordNumber# with the 'radicado' document type?",
    "areYouSureYouWantToPackTheRecord": "Are you sure you want to pack the record?",
    "areYouSureYouWantToPerformTheAdministrativeClosureOfTheRecord": "Are you sure you want to perform the administrative closure of the record?",
    "areYouSureYouWantToReassignTheInternalCommunicationToTheUser'Username'": "Are you sure you want to reassign the internal communication to the user 'Username'?",
    "areYouSureYouWantToReassignTheTasksToUser#User#": "Are you sure you want to reassign the tasks to user #User#?",
    "areYouSureYouWantToRejectTheApprovalRequest": "Are you sure you want to reject the approval request?",
    "areYouSureYouWantToRejectTheCurrentInternalCommunication": "Are you sure you want to reject the current internal communication?",
    "areYouSureYouWantToReopenTheRecord": "Are you sure you want to reopen the record?",
    "areYouSureYouWantToRequestApproval": "Are you sure you want to request approval?",
    "areYouSureYouWantToResetRecordPermissionsInheritance": "Are you sure you want to reset record permissions inheritance?",
    "areYouSureYouWantToResetThePermissionInheritanceOfTheDocument": "Are you sure you want to reset the permission inheritance of the document?",
    "areYouSureYouWantToRespondToTheApprovalRequest": "Are you sure you want to respond to the approval request?",
    "areYouSureYouWantToSaveTheChanges": "Are you sure you want to save the changes?",
    "areYouSureYouWantToSaveTheContact": "Are you sure you want to save the contact?",
    "areYouSureYouWantToSaveTheDocumentType": "Are you sure you want to save the document type?",
    "areYouSureYouWantToSaveTheMetadata": "Are you sure you want to save the metadata?",
    "areYouSureYouWantToSaveThePhysicalLocation": "Are you sure you want to save the physical location?",
    "areYouSureYouWantToSaveTheProcedure": "Are you sure you want to save the procedure?",
    "areYouSureYouWantToSaveTheProcess": "Are you sure you want to save the process?",
    "areYouSureYouWantToSendTheRequest": "Are you sure you want to send the request?",
    "areYouSureYouWantToSetTheVersion#VersionName#AsTheCurrentDocumentRetentionTableVersion": "Are you sure you want to set the version #VersionName# as the current document retention table version?",
    "areYouSureYouWantToUpdateSecurity": "Are you sure you want to update security?",
    "areYouSureYouWantToUpdateTheContactType": "Are you sure you want to update the contact type?",
    "areYouSureYouWantToUpdateTheDecisionTable": "Are you sure you want to update the decision table?",
    "areYouSureYouWantToUpdateTheSecurityLevel": "Are you sure you want to update the security level?",
    "areYouSureYouWantToUpdateTheUser'sSection": "Are you sure you want to update the user's section?",
    "areYouSureYouWantToUploadTheDeliveryVoucher": "Are you sure you want to upload the delivery voucher?",
    "assign": "Assign",
    "assignedForDispatch": "Assigned for Dispatch",
    "assignment": "Assignment",
    "assignmentByClassification": "Assignment by Classification",
    "assignmentByProfile": "Assignment by Profile",
    "assignmentType": "Assignment Type",
    "assignShipment": "Assign Shipment",
    "associateContact": "Associate Contact",
    "associatedBySection": "Associated by Section",
    "associatedDocumentType": "Associated Document Type",
    "associatedKeywords": "Associated Keywords",
    "associatedMetadata": "Associated Metadata",
    "associateDocumentTypes": "Associate Document Types",
    "associatedOutboundFiles": "Associated Outbound Files",
    "associatedRecords": "Associated Records",
    "associateRoleWithButton": "Associate Role with Button",
    "associateUser": "Associate User",
    "associationCreatedSuccessfully": "Association Created Successfully",
    "associationDeletedSuccessfully": "Association Deleted Successfully",
    "attachments": "Attachments",
    "attachmentType": "Attachment Type",
    "author": "Author",
    "authorizedRoles": "Authorized Roles",
    "authorizeNotificationByEmail": "Authorize Notification by Email?",
    "authorizeNotificationOrReceiveCallsOnTheCellPhone": "Authorize Notification or Receive Calls on the Cell Phone?",
    "authorizeToReceiveCallsOnTheLandline": "Authorize to Receive Calls on the Landline?",
    "authorizeToReceiveNotificationAtTheRegisteredAddress": "Authorize to Receive Notification at the Registered Address?",
    "awaitingDigitalSignatureApproval": "Awaiting Digital Signature Approval",
    "axpayerIdentificationNumber(TIN)": "Taxpayer Identification Number (TIN)",
    "basicInformation": "Basic Information",
    "belongs": "Belongs",
    "birthCertificate": "Birth Certificate",
    "box": "Box",
    "branch": "Branch",
    "branches": "Branches",
    "branchStoredSuccessfully": "Branch Stored Successfully",
    "breakInheritance": "Break Inheritance",
    "bulkUpload": "Bulk Upload",
    "businessName": "Business Name",
    "cancel": "Cancel",
    "canceled": "Canceled",
    "cancellationRequest": "Cancellation Request",
    "cancellations": "Cancellations",
    "cancelRequest": "Cancel Request",
    "caseFileDeletedSuccessfully": "Case File Deleted Successfully",
    "caseFileNumber": "Case File Number",
    "caseFiles": "Case Files",
    "caseFileTitle": "Case File Title",
    "category": "Category",
    "cellPhone": "Cell Phone",
    "center": "Center",
    "centralArchive": "Central Archive",
    "centralArchive(Years)": "Central Archive (Years)",
    "certifiedMail": "Certified Mail",
    "changeApprover": "Change Approver",
    "changeApproverUser": "Change Approver User",
    "changeHistory": "Change History",
    "changeName": "Change Name",
    "changeResponsible": "Change Responsible",
    "changeSection": "Change Section",
    "changesSavedSuccessfully": "Changes Saved Successfully",
    "checkSheets": "Check Sheets",
    "chooseAnOption": "Choose An Option",
    "chronologicalOrder": "Chronological Order",
    "cities": "Cities",
    "citizen": "Citizen",
    "citizenshipID": "Citizenship ID",
    "city": "City",
    "cityRequired": "City Required",
    "clarificationContribution": "Clarification Contribution",
    "classification": "Classification",
    "classificationAndCodingPlan(CCD)": "Classification and Coding Plan (CCD)",
    "classificationSavedSuccessfully": "Classification Saved Successfully",
    "classified": "Classified",
    "classifiedInformation": "Classified Information",
    "clear": "Clear",
    "clearFilters": "Clear Filters",
    "clickHereToDownloadSignaX": "Click Here to Download SignaX",
    "clickHereToSeeTheDetailsOfSection#Section#": "Click Here to See the Details of Section #Section#",
    "clickOnceResources": "ClickOnce Resources",
    "close": "Close",
    "closedUserSelection": "Closed User Selection",
    "closeMulti-assignment": "Close Multi-assignment",
    "closure": "Closure",
    "code": "Code",
    "collected": "Collected",
    "completeAssignment": "Complete Assignment",
    "completed": "Completed",
    "componentToRender": "Component to Render",
    "configuration": "Configuration",
    "configureSignature": "Configure Signature",
    "congratulations": "Congratulations",
    "consecutive": "Consecutive",
    "consecutives": "Consecutives",
    "consecutiveSuccessfullyStored": "Consecutive Successfully Stored",
    "conservation": "Conservation",
    "consultMinutes": "Consult Minutes",
    "contact": "Contact",
    "contactIdentificationNumber": "Contact Identification Number",
    "contactInformation": "Contact Information",
    "contacts": "Contacts",
    "contactsCharacterization": "Contacts Characterization",
    "contactStoredCorrectly": "Contact Stored Correctly",
    "contactType": "Contact Type",
    "contactTypes": "Contact Types",
    "contactTypeUpdatedSuccessfully": "Contact Type Updated Successfully",
    "copies": "Copies",
    "copy-IncomingMail": "Copy - Incoming Mail",
    "copy": "Copy",
    "copyActiveDocumentaryTypes": "Copy Active Documentary Types",
    "copyActiveFolders": "Copy Active Folders",
    "copyOfIncomingFile": "Copy of Incoming File",
    "correspondence": "Correspondence",
    "counterRegistration": "Counter Registration",
    "counterRegistration(PhysicalIncomingMail)": "Counter Registration (Physical Incoming Mail)",
    "countries": "Countries",
    "country": "Country",
    "create": "Create",
    "createAssociation": "Create Association",
    "createCity": "Create City",
    "createColumn": "Create Column",
    "createCountry": "Create Country",
    "createdBy": "Created By",
    "createDecision": "Create Decision",
    "createDepartment": "Create Department",
    "createDigitalIncomingFile": "Create Digital Incoming File",
    "createFile": "Create File",
    "createFolder": "Create Folder",
    "createFund": "Create Fund",
    "createHoliday": "Create Holiday",
    "createMetadata": "Create Metadata",
    "createNewItem": "Create New Item",
    "createOrientation": "Create Orientation",
    "createPermission": "Create Permission",
    "createPhysicalIncomingFile": "Create Physical Incoming File",
    "createProcess": "Create Process",
    "createProfile": "Create Profile",
    "createResponseProject": "Create Response Project",
    "createRole": "Create Role",
    "createSection": "Create Section",
    "createSeries": "Create Series",
    "createShippingMethod": "Create Shipping Method",
    "createSubseries": "Create Subseries",
    "createTerminologyBank": "Create Terminology Bank",
    "createTransferSchedule": "Create Transfer Schedule",
    "createVersion": "Create Version",
    "createVersionNumber": "Create Version Number",
    "creatingDecision": "Creating Decision",
    "creation": "Creation",
    "creationDate": "Creation Date",
    "creationOfPhysicalIncomingRecord": "Creation of Physical Incoming Record",
    "custodyCompany": "Custody Company",
    "custom": "Custom",
    "customField#No.#": "Custom Field #No.#",
    "dataTypes": "Data Types",
    "date": "Date",
    "dateOfBirth": "Date of Birth",
    "day": "Day",
    "deactivate": "Deactivate",
    "deactivateBranch(es)": "Deactivate Branch(es)",
    "deactivateProfile(s)": "Deactivate Profile(s)",
    "decisionName": "Decision Name",
    "decisions": "Decisions",
    "decisionStoredSuccessfully": "Decision Stored Successfully",
    "decisionTable": "Decision Table",
    "decisionTableDeletedSuccessfully": "Decision Table Deleted Successfully",
    "decisionTables": "Decision Tables",
    "default": "Default",
    "defaultUser": "Default User",
    "definitiveAnswer": "Definitive Answer",
    "delete": "Delete",
    "deleteAlert": "Delete Alert",
    "deleteAssociation": "Delete Association",
    "deleteCurrentAlert": "Delete Current Alert",
    "deleteDecisionTable": "Delete Decision Table",
    "deleteDocument": "Delete Document",
    "deleteDocumentRetentionTable": "Delete Document Retention Table",
    "deleteDocumentType": "Delete Document Type",
    "deleteEntityType": "Delete Entity Type",
    "deleteFile": "Delete File",
    "deleteFolder": "Delete Folder",
    "deleteIncomingFile": "Delete Incoming File",
    "deleteInternalCommunication": "Delete Internal Communication",
    "deleteItem": "Delete Item",
    "deleteLink": "Delete Link",
    "deletePermission": "Delete Permission",
    "deleteRecord": "Delete Record",
    "deletionReason": "Deletion Reason",
    "delivered_Plural": "Delivered",
    "delivered_Singular": "Delivered",
    "deliveryVoucher": "Delivery Voucher",
    "deliveryVouchers": "Delivery Vouchers",
    "department": "Department",
    "departments": "Departments",
    "description": "Description",
    "descriptionOfTheOrientation": "Description of the Orientation",
    "desktopRuntimeEnvironment": "Desktop Runtime Environment",
    "details": "Details",
    "didTheOrientationGeneratePQR": "Did the Orientation Generate PQR?",
    "didTheReceivedServiceMeetYourExpectations": "Did the Received Service Meet Your Expectations?",
    "digitalIncomingFile": "Digital Incoming File",
    "digitalIncomingFileSignature": "Digital Incoming File Signature",
    "digitalOutgoingFile": "Digital Outgoing File",
    "digitalPQRNo": "Digital PQR No.",
    "digitalRecordCreatedAndAssignedTo#User#": "Digital Record Created and Assigned to #User#",
    "digitalRecordDraftCreatedByTheUser": "Digital Record Draft Created by the User",
    "digitalSignature": "Digital Signature",
    "digitizationOfIncomingRecords": "Digitization of Incoming Records",
    "digitizationOfOutgoingRecords": "Digitization of Outgoing Records",
    "digitized_Plural": "Digitized",
    "digitized_Singular": "Digitized",
    "digitizedByMe": "Digitized by Me",
    "disabilities": "Disabilities",
    "discard": "Discard",
    "displaysAllPendingOutgoingMailsForCancellation": "Displays All Pending Outgoing Mails for Cancellation",
    "distribution": "Distribution",
    "distributions": "Distributions",
    "documentalType": "Documental Type",
    "documentaryInventory": "Documentary Inventory",
    "documentaryInventoryReport": "Documentary Inventory Report",
    "documentaryType": "Documentary Type",
    "documentAuthor": "Document Author",
    "documentCreatedWithNumber#number#": "Document Created with Number #number#",
    "documentDate": "Document Date",
    "documentDeliveries": "Document Deliveries",
    "documentDescription": "Document Description",
    "documentFlowExecution": "Document Flow Execution",
    "documentInventoryTemplates": "Document Inventory Templates",
    "documentManager": "Document Manager",
    "documentName": "Document Name",
    "documentNumber": "Document Number",
    "documento": "Document",
    "documentRetentionTableCreatedSuccessfully": "Document Retention Table Created Successfully",
    "documentRetentionTableImportedFromExcel": "Document Retention Table Imported from Excel",
    "documentRetentionTables": "Document Retention Tables",
    "documentRetentionTableVersions": "Document Retention Table Versions",
    "documents": "Documents",
    "documentSource": "Document Source",
    "documentsPendingReceipt": "Documents Pending Receipt",
    "documentsReceivedSuccessfully": "Documents Received Successfully",
    "documentTitle": "Document Title",
    "documentType": "Document Type",
    "documentType#FolderName#Added": "Document Type #Folder Name# Added",
    "documentTypeDeleted": "Document Type Deleted",
    "documentTypeOrigin": "Document Type Origin",
    "documentTypeStoredSuccessfully": "Document Type Stored Successfully",
    "documentUpdatedSuccessfully": "Document Updated Successfully",
    "documentValuationTableVersions": "Document Valuation Table Versions",
    "documentVersions": "Document Versions",
    "documentViewer": "Document Viewer",
    "download": "Download",
    "downloadAll": "Download All",
    "downloadFiltered.": "Download Filtered",
    "downloadMetadata": "Download Metadata",
    "downloadTemplate": "Download Template",
    "downloadTheBulkUploadTemplate": "Download the Bulk Upload Template",
    "doYouConsiderTheReceivedInformationUseful": "Do You Consider the Received Information Useful?",
    "doYouWantToCompleteTheSurvey": "Do You Want to Complete the Survey?",
    "draft": "Draft",
    "draftIncomingFileDeletedSuccessfully": "Draft Incoming File Deleted Successfully",
    "draftingResponseToInternalCommunication": "Drafting Response to Internal Communication",
    "dragAFileOrClickToSelect": "Drag a File or Click to Select *",
    "dragFilesOrClickBelowThisTitleToSelect": "Drag Files or Click Below this Title to Select",
    "dropAFileOrClickToSelect": "Drop a File or Click to Select",
    "dVD": "DVD",
    "east": "East",
    "edit": "Edit",
    "editAlert": "Edit Alert",
    "editConsecutive": "Edit Consecutive",
    "editContact": "Edit Contact",
    "editContactType": "Edit Contact Type",
    "editDocumentType-TRD": "Edit Document Type - TRD",
    "editFund": "Edit Fund",
    "editHoliday": "Edit Holiday",
    "editing": "Editing",
    "editor": "Editor",
    "editPQRSClassification": "Edit PQRS Classification",
    "editProcedure": "Edit Procedure",
    "editRules": "Edit Rules",
    "editSectionTRD": "Edit Section - TRD",
    "editSeriesTRD": "Edit Series - TRD",
    "editShippingMethod": "Edit Shipping Method",
    "editTemplate": "Edit Template",
    "editTRDSubseries": "Edit TRD Subseries",
    "editVersion": "Edit Version",
    "educationalLevel": "Educational Level",
    "educationalLevels": "Educational Levels",
    "electronic": "Electronic",
    "electronicIndex": "Electronic Index",
    "electronicIndexExportedAsXML": "Electronic Index Exported as XML",
    "electronicResponse": "Electronic Response",
    "electronicSignature": "Electronic Signature",
    "elementsByPage": "Elements by Page",
    "emailAddress": "Email Address",
    "emailNotifications": "Email Notifications",
    "enableAnotherPQRSClassification": "Enable Another PQRS Classification",
    "enableBetaFeatures": "Enable beta features",
    "encryptOnSave": "Encrypt on Save",
    "end": "End",
    "enddate": "End Date",
    "endDate": "End Date",
    "endDateOfRecordCreation": "End Date of Record Creation",
    "entity": "Entity",
    "entityType": "Entity Type",
    "entityTypeDeletedSuccessfully": "Entity Type Deleted Successfully",
    "entityTypes": "Entity Types",
    "entityTypeSavedSuccessfully": "Entity Type Saved Successfully",
    "error": "Error",
    "ethnicGroups": "Ethnic Groups",
    "excel": "Excel",
    "executionType": "Execution Type",
    "exitFullScreen": "Exit Full Screen",
    "expiry": "Expiry",
    "export": "Export",
    "exportAll": "Export All",
    "exportAllPages": "Export All Pages",
    "exportAllPagesAsTemplates": "Export All Pages as Templates",
    "exportAsTXT": "Export as TXT",
    "exportAsXML": "Export as XML",
    "exportCurrentPage": "Export Current Page",
    "exportCurrentPageAsATemplate": "Export Current Page as a Template",
    "exportCurrentResults": "Export Current Results",
    "exportDirectory": "Export Directory",
    "exportFiltered": "Export Filtered",
    "exportMetadata": "Export Metadata",
    "exportToPDF": "Export to PDF",
    "extension": "Extension",
    "extensionOfIncomingMail": "Extension of Incoming Mail",
    "extensions": "Extensions",
    "extensionsDeletedSuccessfully": "Extensions Deleted Successfully",
    "external": "External",
    "externalCopies": "External Copies",
    "externalDocument": "External Document",
    "externalField": "External Field",
    "favorites": "Favorites",
    "fAX": "FAX",
    "fieldType": "Field Type",
    "file": "File",
    "fileDeleted": "File Deleted",
    "fileName": "File Name",
    "fileNotFound": "File Not Found",
    "fileStatuses": "File Statuses",
    "fileStorage": "File Storage",
    "fileTransfer": "File Transfer",
    "filter": "Filter",
    "filters": "Filters",
    "finalApproval": "Final Approval",
    "finalDisposition": "Final Disposition",
    "fingerprintValue": "Fingerprint Value",
    "finish": "Finish",
    "finishTurno": "Finish Shift",
    "firstCall": "First Call",
    "firstName": "First Name",
    "folder": "Folder",
    "folder#FolderName#WasAdded": "Folder #Folder Name# Was Added",
    "folder#FolderName#WasDeleted": "Folder #Folder Name# Was Deleted",
    "folderDeleted": "Folder Deleted",
    "folders": "Folders",
    "folderSavedSuccessfully": "Folder Saved Successfully",
    "foreigner'sID": "Foreigner's ID",
    "format": "Format",
    "from": "From",
    "fullScreen": "Full Screen",
    "fullView": "Full View",
    "function": "Function",
    "functionToExecuteInTheAPI": "Function to Execute in the API",
    "fund": "Fund",
    "fundItBelongsTo": "Fund It Belongs To",
    "funds": "Funds",
    "fundStoredSuccessfully": "Fund Stored Successfully",
    "gender": "Gender",
    "genders": "Genders",
    "general": "General",
    "generalSearch": "General Search",
    "generateSheet": "Generate Sheet",
    "geography": "Geography",
    "goToInbox": "Go to Inbox",
    "goToRecord": "Go to Record",
    "goToSection": "Go to Section",
    "group": "Group",
    "grupoEtnido": "Ethnic Group",
    "guideNumber": "Guide Number",
    "handwrittenSignature": "Handwritten Signature",
    "headquarters": "Headquarters",
    "helpdeskRegistration": "Helpdesk Registration",
    "helpdeskRegistration(DigitalIncomingMail)": "Helpdesk Registration (Digital Incoming Mail)",
    "high_Female": "High (Female)",
    "high_Male": "High (Male)",
    "historical": "Historical",
    "historicalArchive": "Historical Archive",
    "history": "History",
    "holidays": "Holidays",
    "iD": "ID",
    "identification": "Identification",
    "identificationnumber": "Identification Number",
    "identificationNumber": "Identification Number",
    "identificationType": "Identification Type",
    "identityCard": "Identity Card",
    "ifYouChangeTheResponsibleForTheInternalCommunication,UnsavedChangesInTheFormWillBeDeleted.AreYouSureYouWantToUpdateTheApprover": "If you change the responsible for the internal communication, unsaved changes in the form will be deleted. Are you sure you want to update the approver?",
    "ifYouDeleteTheDecisionTable,ItCannotBeRecovered.AreYouSureYouWantToDeleteTheSelectedDecisionTable": "If you delete the decision table, it cannot be recovered. Are you sure you want to delete the selected decision table?",
    "ifYouDeleteTheDocumentRetentionTable,TheFolder,DocumentType,AndPermissionSettingsCannotBeRestored.AreYouSureYouWantToContinue": "If you delete the document retention table, the folder, document type, and permission settings cannot be restored. Are you sure you want to continue?",
    "ifYouHaveTheseComponentsInstalled,YouCanLaunchTheApplicationNow.Otherwise,ClickTheButtonBelowToInstallThePrerequisitesAndRunTheApplication.": "If you have these components installed, you can launch the application now. Otherwise, click the button below to install the prerequisites and run the application.",
    "ifYouLockTheRecord,UsersWillNoLongerBeAbleToCreate,Edit,OrDeleteDocuments": "If you lock the record, users will no longer be able to create, edit, or delete documents.",
    "ifYouUnlockTheRecord,UsersWillBeAbleToCreate,Edit,OrDeleteDocuments": "If you unlock the record, users will be able to create, edit, or delete documents.",
    "import": "Import",
    "important": "The assignment of permissions for viewing documents may take several minutes to complete.",
    "importProject": "Importar proyecto",
    "inApproval": "In Approval",
    "inbox": "Inbox",
    "inbox#tasksOf#tasks": "Inbox #tasks of #tasks",
    "inboxColumns": "Inbox Columns",
    "includeInFile": "Include in File",
    "includeMailInRecord-DocumentFlow": "Include Mail in Record - Document Flow",
    "inclusion": "Inclusion",
    "incomingFile": "Incoming File",
    "incomingFileArchivedSuccessfully": "Incoming File Archived Successfully",
    "incomingFiledIncoming": "Incoming Filed Incoming",
    "incomingFileInDraft": "Incoming File In Draft",
    "incomingFileInMulti-assignedProgress": "Incoming File In Multi-assigned Progress",
    "incomingFileNo.#IncomingnumberInProgress#": "Incoming File No. #Incoming number In Progress#",
    "incomingFileNo": "Incoming File No.",
    "incomingFileNumber": "Incoming File Number",
    "incomingFileService": "Error deleting incoming file draft. Invalid request, the incoming file to be deleted is not in draft state.",
    "incomingMailInProgress": "Incoming Mail In Progress",
    "incomingMailReport": "Incoming Mail Report",
    "incomingRecordNo.#Number#CreatedSuccessfully": "Incoming Record No. #Number# Created Successfully",
    "incomingRecordNumber": "Incoming Record Number",
    "incomingRecordSuccessfullyDelegated": "Incoming Record Successfully Delegated",
    "incompleteIncomingRecords": "Incomplete Incoming Records",
    "incorporationDate": "Incorporation Date",
    "informationRequest": "Information Request",
    "informationRequestHistory": "Information Request History",
    "informationRequestResponse": "Information Request Response",
    "initials": "Initials",
    "inProcess": "In Process",
    "inputFileNumber": "Input File Number",
    "inputs": "Inputs",
    "install": "Install",
    "internal": "Internal",
    "internalCommunication-ApprovalRequest": "Internal Communication - Approval Request",
    "internalCommunication-Rejected": "Comunicado interno - Rechazado",
    "internalCommunication": "Comunicado interno",
    "internalCommunicationApprovedSuccessfully": "Comunicado interno aprobado con éxito.",
    "internalCommunicationCreatedSuccessfully": "Comunicado interno creado con éxito.",
    "internalCommunicationDelegatedSuccessfully": "Comunicado interno delegado exitosamente",
    "internalCommunicationDeletedSuccessfully": "Comunicado interno eliminado con éxito.",
    "internalCommunicationInProgress": "Comunicado interno en trámite",
    "internalCommunicationMarkedAsReadSuccessfully": "Comunicado interno marcado como leído con éxito",
    "internalCommunicationProject": "Proyecto de comunicado interno",
    "internalCommunicationRejectedSuccessfully": "Comunicado interno rechazado con éxito.",
    "internalCommunicationResponseDrafting#internalcommunication": "Elaboración respuesta a comunicado interno #comunicadointerno",
    "internalCommunicationsReport": "Reporte comunicados internos",
    "internalNotifications": "Notificaciones internas",
    "internalProcedure": "Tramite interno",
    "international": "Internacional",
    "inThisSection,YouWillFindTheUsersResponsibleForProjectingAndApprovingInternalCommunication": "En este apartado se encuentran los usuarios encargados de proyectar y aprobar la comunicacion interna",
    "invalidRequest,TheIncomingFileCannotHaveAPreviouslyAssignedNumber": "Solicitud inválida, el radicado de entrada no puede tener un número previamente asignado.",
    "invoice": "Factura",
    "itemDeleted": "Elemento eliminado",
    "itemDeletedSuccessfully": "Elemento eliminado correctamente",
    "itemType": "Tipo de elemento",
    "itIsAllInformationThatASubjectObligatedGenerates,Obtains,Acquires,OrControlsInTheirCapacityAsSuch.Law1712/2014ThatHasBeenLegallyDeclaredOrByItsOwner,PubliclyKnownAndAccessibleToAnyone.E.g.,AccountabilityPresentedByTheEntity,ActionPlanOfTheEntity,OpenData,AmongOthers": "Es toda información que un sujeto obligado genere, obtenga, adquiera, o controle en su calidad de tal. Ley 1712/2014 que ha sido declarada legalmente o por su propietario, de conocimiento público y accesible a cualquier persona. Ej. Rendición de cuentas presentada por la entidad, Plan de acción de la Entidad, datos abiertos, entre otros",
    "itIsThatInformationThat,BeingInThePossessionOrCustodyOfASubjectObligatedInTheirCapacityAsSuch,BelongsToTheOwn,Private,OrSemi-privateSphereOfANaturalOrLegalPerson,SoItsAccessMayBeDeniedOrExcepted,ProvidedThatItInvolvesLegitimateAndNecessaryCircumstancesAndTheParticularOrPrivateRightsEnshrinedInArticle18OfThisLaw;Law1712/2014": "Es aquella información que estando en poder o custodia de un sujeto obligado en su calidad de tal, pertenece al ámbito propio, particular y privado o semiprivado de una persona natural o jurídica por lo que su acceso podrá ser negado o exceptuado, siempre que se trate de las circunstancias legítimas y necesarias y los derechos particulares o privados consagrados en el artículo 18 de esta ley; Ley 1712/2014",
    "itIsThatInformationWhich,BeingInThePossessionOrCustodyOfASubjectObligatedInTheirCapacityAsSuch,IsExemptFromAccessByTheCitizenryDueToHarmToPublicInterestsAndInComplianceWithAllTheRequirementsEstablishedInArticle19OfThisLaw;Law1712/2014": "Es aquella información que estando en poder o custodia de un sujeto obligado en su calidad de tal, es exceptuada de acceso a la ciudadanía por daño a intereses públicos y bajo cumplimiento de la totalidad de los requisitos consagrados en el artículo 19 de esta ley; Ley 1712/2014",
    "itWasNotPossibleToConnectToTheSignaXApplication.PleaseMakeSureTheApplicationIsInstalledAndRunningCorrectly": "No fue posible conectarse a la aplicación SignaX. Por favor asegurese que la aplicación esta instalada y se ejecuta correctamente",
    "jobTitle": "Job Title",
    "keyword": "Keyword",
    "keywords": "Keywords",
    "landlinePhoneExtensionNumberRequired": "Extension number required",
    "landlinePhoneRequired": "Phone number required",
    "lastName": "Last Name",
    "libraries": "Libraries",
    "link": "Link",
    "linkDeletedSuccessfully": "Enlace eliminado correctamente",
    "linkedDocument": "Documento enlazado",
    "linkedFiles": "Radicados vinculados",
    "linkRequests": "Enlazar Peticiones",
    "loadExtension": "Cargar extensión",
    "loading": "Cargando",
    "loadingDocuments": "Cargando documentos",
    "loadingForm": "Cargando formulario",
    "loadingImportantFileInformation": "Cargando información importante del expediente",
    "loadMoreItems": "Cargar mas elementos",
    "loadMoreTasks": "Cargar mas tareas",
    "loadServerExtension": "Cargar extensión de servidor",
    "loadUI": "Cargar UI",
    "loadUIExtension": "Cargar extensión UI",
    "local": "Local",
    "location": "Location",
    "locationDeletedSuccessfully": "Location Deleted Successfully",
    "locationSavedSuccessfully": "Location Saved Successfully",
    "lock": "Bloqueo",
    "lockRecord": "Bloquear expediente",
    "loginName": "Login name",
    "low": "Bajo",
    "magazine": "Revista",
    "mainFile": "Archivo principal",
    "mainRecipients": "Destinatarios principales",
    "managementArchive(Years)": "Archivo de gestión (Años)",
    "managementFileReport": "Reporte archivo gestión",
    "manageTrays": "Gestionar bandejas",
    "markAsRead.": "Marcar como leído",
    "mAS": "Módulo de atención y servicio",
    "massDocumentSigning": "Firma masiva de documentos",
    "maximumLength": "Longitud máxima",
    "maximumResponseDate": "Fecha maxima de respuesta",
    "maximumResponseTime": "Tiempo máximo de respuesta",
    "meansOfOrientation": "Medio de la orientación",
    "meansOfReception": "Medio de recepción",
    "mediaType": "Tipo soporte",
    "medium_Female": "Media",
    "medium_Male": "Medio",
    "metadata_Plural": "Metadatos",
    "metadata_Singular": "Metadato",
    "metadataCategories": "Categorías de metadatos",
    "metadataForIncomingMail": "Metadatos radicado entrada",
    "metadataForOutgoingMail": "Metadatos radicado salida",
    "metadataSuccessfullyStored": "Metadatos almacenados correctamente",
    "minimumLength": "Longitud minima",
    "mobilePhoneRequired": "Teléfono celular requerido",
    "modificationDate": "Fecha modificación",
    "modifiedBy": "Modificado por",
    "moduleName": "Nombre del módulo",
    "modules": "Módulos",
    "month": "Mes",
    "moveDocument": "Mover documento",
    "moveToFolder": "Mover a carpeta",
    "multi-assigned": "Multiasignados",
    "multi-assignment": "Multiasignación",
    "myApprovals": "Mis aprobaciones",
    "myFUID": "Mis FUID",
    "myRequests": "Mis solicitudes",
    "name": "Name",
    "nameOrLegalEntity": "Nombre o razón social",
    "namesOrBusinessName": "Nombres o razón social",
    "national": "Nacional",
    "neighborhood": "Barrio",
    "neighborhoodRequired": "Barrio requerido",
    "new": "New",
    "newAlert": "Nueva alerta",
    "newBusinessUser": "Nuevo usuario empresarial",
    "newContact": "Nuevo contacto",
    "newDecision": "Nueva decisión",
    "newDocumentRetentionTable": "Nueva tabla de retención documental",
    "newDocumentType-TRD": "Nuevo tipo documental - TRD",
    "newFolder": "Nuevo carpeta",
    "newFund": "Nuevo fondo",
    "newPQRSClassification": "Nueva clasificación PQRS",
    "newProcedure": "Nuevo trámite",
    "newRule": "Nueva regla",
    "newSeries-TRD": "Nueva serie - TRD",
    "newShippingMethod": "Nuevo medio de envío",
    "newUser": "Nuevo usuario",
    "newZone": "Nueva zona",
    "next": "Siguiente",
    "nextTurno": "Siguiente turno",
    "no": "No",
    "noDataToDisplayAtThisTime": "No hay datos para mostrar en este momento",
    "noDocumentsWereAttached": "No se adjuntaron documentos",
    "noInformationToDisplay": "No hay información para mostrar",
    "noInformationToDisplayAtThisTime": "No hay información para mostrar en este momento",
    "noMatchingDataFoundForTheSearchFilters": "No se encontraron datos que coincidan con los filtros de búsqueda",
    "none": "Ninguno",
    "noRecordsToDisplay": "No hay registros para mostrar",
    "noResultsWereFoundForTheEnteredSearchCriteria": "No se encontraron resultados para los criterios de búsqueda ingresados.",
    "north": "Norte",
    "note": "Nota",
    "notifications": "Notificaciones",
    "notificationsToBeSent": "Notificaciones por enviar",
    "number": "Number",
    "numberOfPages": "Cantidad de folios",
    "numeroReferencia": "Número de referencia",
    "observations": "Observaciones",
    "occupationOrProfession": "Ocupación u oficio",
    "onlyUsersOfSection#sectionName#CanBeSetAsRecordResponsibles": "Solo los usuarios de la sección #nombre de la sección# puedes establecerse como responsables del expediente.",
    "openUserSelection": "Selección abierta de usuarios",
    "operation": "operación",
    "operationPerformedSuccessfully": "Operación efectuada correctamente",
    "order": "Orden",
    "orientation": "Orientación",
    "orientationNumber": "Número de orientación",
    "orientationReceptionMethods": "Medios de recepción orientación",
    "orientationSectors": "Sectores orientación",
    "origin": "Origen",
    "other": "Otro",
    "otherAttachments": "Otros anexos",
    "outgoingMailInProgress": "Radicado de salida en tramite",
    "outgoingMailReport": "Reporte radicados de salida",
    "outgoingMailReturnToElectronicHeadquarters": "Radicado Salida Devolucion Sede Electronica",
    "outputs": "Salidas",
    "pack": "Empaquetar",
    "packagedCaseFiles": "Expedientes empaquetados",
    "packaging": "Empaquetamiento",
    "packRecord": "Empaquetar expediente",
    "paper": "Papel",
    "paperAndElectronic": "Papel y Electrónico",
    "parameterDeletedSuccessfully": "Parámetro eliminado correctamente",
    "parameters": "Parámetros",
    "parameterSavedSuccessfully": "Parámetro almacenado correctamente",
    "parent": "Padre",
    "parentFund": "Fondo padre",
    "parentSection": "Sección padre",
    "password": "Password",
    "pBX": "Pbx",
    "pDFFile": "Archivo * .pdf",
    "pending": "Pendientes",
    "pendingApprovalOfInternalCommunication": "Pendiente aprobación comunicado interno",
    "pendingConservation": "Pendientes conservación",
    "pendingForReceipt": "Pendientes por recibir",
    "pendingQualitativeSelection": "Pendientes selección cualitativa",
    "pendingQuantitativeSelection": "Pendientes selección cuantitativa",
    "pendingRemoval": "Pendientes eliminación",
    "permission": "Permiso",
    "permissions": "Permisos",
    "permissionsWereGrantedToTheSection#sectionName#": "Se concedió permisos a la sección #nombre de la sección#",
    "permissionType": "Tipo de permiso",
    "personalInformation": "Información personal",
    "phone": "Teléfono",
    "physical": "Fisico",
    "physicalAddress": "Dirección fisica",
    "physicalIncomingFile": "Radicado de entrada fisico",
    "physicalIncomingFileSignature": "Firma Radicados Fisicos",
    "physicalLocation": "Ubicación física",
    "physicalOutgoingFile": "Radicado de salida fisico",
    "physicalOutgoingFileProject": "Proyecto de radicado de salida fisico",
    "physicalResponse": "Respuesta fisica",
    "physicalTokenSerial": "Serial token fisico",
    "postalCode": "Código postal",
    "pQRClassification": "Clasificación PQR",
    "pQRNo.#PqrnumberInProgress#.": "PQR No. # de pqr en tramite #",
    "pQROutgoingInProgress": "PQR salida en tramite",
    "pQRSClassifications": "Clasificaciones PQRS",
    "pQRSReport": "Reporte PQRS",
    "pqrWeb": "PqrWeb",
    "preferredAttention": "Atención preferencial",
    "prefix": "Prefijo",
    "preliminaryResponse": "Respuesta preliminar",
    "preview": "Vista previa",
    "primaryTransfer": "Transferencia primaria",
    "primaryTransferEndDate": "Fecha fin transferencia primaria",
    "primaryTransferNumber": "Número transferencia primaria",
    "primaryTransferStartDate": "Fecha inicio transferencia primaria",
    "printed": "Impreso",
    "priority": "Prioridad",
    "procedure": "Trámite",
    "procedureCode": "Código procedimiento",
    "procedureDescription": "Descripción procedimiento",
    "procedureExecutionType": "Tipo de ejecución trámite",
    "procedureName": "Nombre procedimiento",
    "procedures": "Trámites",
    "procedureSavedSuccessfully": "Tramite almacenado correctamente",
    "procesoX_AllowUploadDocumentUsingActivityInstance": "Permitir cargar documentos por medio de la instancia de proceso",
    "procesoX_Function_ExistConstant_ArgumentNullException": "ProcesoxErrors.Functions.ExistConstant.ArgumentNullException",
    "procesoX_ShowErrorsSummaryInDialog": "Mostrar resumen de errores en cuadro de dialogo",
    "process": "Process",
    "processCompletedSuccessfully": "Proceso completado correctamente",
    "processInitiatorUser": "Usuario que inicia el flujo",
    "producingOffice": "Oficina productora",
    "profession": "Profesion",
    "professions": "Profesiones",
    "profile": "Profile",
    "profiles": "Perfiles",
    "projectingUser": "Usuario proyectante",
    "projectingUserSection": "Sección usuario proyectante",
    "projector": "Proyector",
    "properties": "Propiedades",
    "property": "Propiedad",
    "propertyCreatedSuccessfully": "Propiedad creada correctamente",
    "provideAnExtension": "Aportar ampliación",
    "provideInformation": "Aportar información",
    "public": "Público",
    "publicAttention": "Atención público",
    "publicComplaintsAndRequests": "PQR",
    "publicInformation": "Información Pública",
    "publishedInternalCommunication": "Comunicado interno publicado",
    "qualitativeSelection": "Selección Cualitativa",
    "quantitativeSelection": "Selección cuantitativa",
    "quantity": "Cantidad",
    "query": "Consulta",
    "queryFrequency": "Frecuencia de consulta",
    "read,Create,AndEditAllDocumentTypes": "Leer, crear y editar todos los tipos documentales",
    "read,Create,AndEditSpecificDocumentTypes": "Leer, crear y editar tipos documentales especificos",
    "readAllDocumentaryTypes": "Leer todos los tipos documentales",
    "readAllDocumentTypes": "Leer todos los tipos documentales",
    "readSpecificDocumentaryTypes": "Leer tipos documentales especificos",
    "readSpecificDocumentTypes": "Leer tipos documentales especificos",
    "readWriteAllDocumentaryTypes": "Leer, crear y editar todos los tipos documentales",
    "readWriteSpecificDocumentaryTypes": "Leer, crear y editar tipos documentales especificos",
    "reassign": "Reasignar",
    "reassignInternalCommunication": "Reasignar comunicado interno",
    "reassignment": "Reasignación",
    "reassignTask": "Reasignar tarea",
    "reassignTasks": "Reasignar tareas",
    "rECapture": "Captura RE",
    "receive": "Recibir",
    "received": "Recibido",
    "receiveDocuments": "Recibir documentos",
    "receivingPoint": "Punto de radicación",
    "receptionDate": "Fecha de recepción",
    "receptionMode": "Modo de recepción",
    "recipient": "Destinatario",
    "reclassify": "Reclasificar",
    "reconnected": "Reconectar",
    "record#URINumber#HasNoAssociatedDocuments": "El expediente #numero URI# no tiene documentos asociados",
    "recordConsultedByUser#User#": "Radicado consultado por el usuario # usuario #",
    "recordCreated_Audit": "El usuario #USUARIO# ha consultado el expediente",
    "recordCreated": "Se creó expediente",
    "recordCreatedSuccessfully": "Expediente creado correctamente",
    "recordDeletedFromTheManagementFile": "Expediente eliminado del archivo de gestión",
    "recordDeletedSuccessfully": "Registro eliminado correctamente",
    "recordDocumentOrder": "Orden documento expediente",
    "recordHistory": "Historial expediente",
    "recordLink": "Enlace de radicado",
    "recordLocation": "Ubicación del expediente",
    "recordNo.": "Expediente No.",
    "recordNumber": "Número expediente",
    "recordPackaging": "Empaquetamiento de expedientes",
    "recordReopened.Reason": "¿Está seguro que desea reabrir el expediente?",
    "recordReopenedSuccessfully": "Expediente reabierto con éxito",
    "recordReports": "Reportes de expediente",
    "records": "Actas",
    "recordStoredSuccessfully": "Registro almacenado correctamente",
    "recordUnlocked": "Expediente desbloqueado",
    "referenceNumber": "Número de referencia",
    "referralLetter": "Oficio remisorio",
    "refresh": "Actualizar",
    "registerOrientation": "Registrar orientación",
    "reject": "Rechazar",
    "rejectApprovalRequest": "Rechazar solicitud de visto bueno",
    "rejectedApproval": "Rechazado visto bueno",
    "rejectedInternalCommunication": "Comunicado interno rechazada",
    "rejectInternalCommunication": "Rechazar comunicado interno",
    "removal": "Eliminación",
    "rename": "Renombrar",
    "reopening": "Reapertura",
    "reopenRecord": "Reabrir expediente",
    "reports": "Reportes",
    "representative'sName": "Nombre representante",
    "request": "Solicitud",
    "requestApproval": "Solicitar aprobación",
    "requestComments": "Observaciones de la solicitud",
    "requestDate": "Fecha solicitud",
    "requestedOn": "Solicitado el",
    "requestedOn#date#timeAndRespondedOn#date#time(#minutes)": "Solicitado el #fecha #hora y respondido el #fecha #hora (#minutos)",
    "requestInformation": "Solicitar información",
    "requestLinking": "Enlace de peticiones",
    "requestVoBo": "Solicitar visto bueno",
    "required": "Requerido",
    "requiredField": "Campo requerido",
    "requiresResponse": "Requiere respuesta",
    "requiresShippingGuide": "Requiere guía de envío",
    "rescheduleDelivery": "Reagendar envio",
    "resendReturnedPhysicalOutgoingMail": "Reenviar radicado salida fisico devuelto",
    "reserved": "Reservado",
    "reservedInformation": "Información reservada",
    "resetInheritance": "Restablecer herencia",
    "respond": "Responder",
    "respondToApproval": "Responder visto bueno",
    "respondToApprovalRequest": "Responder solicitud de visto bueno",
    "respondToApprovalRequests.": "Responder solicitudes de Vo.Bo",
    "respondToConceptRequest": "Responder solicitud de concepto",
    "respondToInternalCommunication": "Responder comunicado interno",
    "respondToPQRApprovalRequest": "Responder solicitud de visto bueno PQR",
    "respondToRequestForApprovalOfInternalCommunication": "Responder solicitud de visto bueno comunicado interno",
    "respondToVoBoRequest": "Responder solicitud de Vo.Bo",
    "response": "Respuesta",
    "response15TimeUnit": " respuesta 15 Unidad de tiempo",
    "responseDate": "Fecha de respuesta",
    "responsePreference": "Preferencia de la respuesta",
    "responsesToApprovalRequest": "Respuestas solicitud de visto bueno",
    "responsesToApprovalRequests": "Respuestas solicitudes de Vo.Bo",
    "responsesToInformationRequest": "Respuestas solictud de información",
    "responsesToInformationRequests": "Respuestas solicitud de información",
    "responseToInternalCommunication": "Respuesta comunicado interno",
    "responseToRequestForClarification": "Respuesta de solicitud de aclaración",
    "responsible": "Responsable",
    "responsibleAlert": "Alerta responsable",
    "responsibleAlertTime(days)": "Tiempo alerta responsable (días)",
    "responsibleChangedSuccessfully": "Responsable cambiado con éxito",
    "responsibles": "Responsables",
    "responsibleUser": "Usuario Responsable",
    "result": "Resultado",
    "retentionTableViewer": "Visor tabla de retención documental",
    "retentionTimeInCentralArchive(Years)": "Tiempo en archivo central (Años)",
    "retentionTimeInManagementArchive(Years)": "Tiempo en archivo gestión (Años)",
    "return": "Devolver",
    "returned_Plural": "Devueltos",
    "returned_Singular": "Devuelto",
    "returnedComments": "Comentarios de la devolución",
    "returnReasons": "Motivos de devolución",
    "review": "Revisar",
    "role": "Rol",
    "roles": "Roles",
    "roleSavedSuccessfully": "Role Saved Successfully",
    "router": "Router",
    "rSCapture": "Captura RS",
    "rules": "Rules",
    "save": "Save",
    "saveBranch": "Save branch",
    "saveChanges": "Save changes",
    "saveConsecutive": "Save consecutive",
    "saveContact": "Save contact",
    "saveDocumentType": "Save document type",
    "saveHoliday": "Save holiday",
    "saveMetadata": "Save metadata",
    "savePQRSClassification": "Guardar clasificación PQRS",
    "saveProcedure": "Save procedure",
    "saveReturnReason": "Save return reason",
    "saveSubseries": "Save subserie",
    "saveZone": "Save zone",
    "schedule": "Schedule",
    "scheduleStoredSuccessfully": "Schedule Stored Successfully",
    "scope": "Scope",
    "search": "Search",
    "searchDocument": "Search Document",
    "searchExistingFile": "Search Existing File",
    "searchForContactsByFilteringByName": "Search Contacts by Filtering by Name",
    "searchForIncomingFile": "Search for Incoming File",
    "searchForIncomingRecords,OutgoingRecords,AndInternalCommunications,FilteringByNumber": "Search for Incoming Records, Outgoing Records, and Internal Communications, Filtering by Number",
    "searchForUsersOrSections": "Search for Users or Sections",
    "searchInClassifiedAccessRecords": "Search in Classified Access Records",
    "searchInPublicAccessRecords": "Search in Public Access Records",
    "searchInReservedAccessRecords": "Search in Reserved Access Records",
    "searchResult": "Search Result",
    "searchTopicsByFilteringByName": "Search Topics by Filtering by Name",
    "searchType": "Search Type",
    "seccion": "Section",
    "secondaryRecipients": "Secondary Recipients",
    "secondaryTransfer": "Secondary Transfer",
    "secondCall": "Second Call",
    "section": "Section",
    "sectionCode": "Section Code",
    "sectionCreated": "Section Created",
    "sectionResponsibleForProcessingTheIncomingCorrespondence": "Section Responsible for Processing the Incoming Correspondence",
    "sections": "Sections",
    "sectionStoredSuccessfully": "Section Stored Successfully",
    "sectionUpdated": "Section Updated",
    "sector": "Sector",
    "secureMethod": "Secure Method",
    "security": "Security",
    "securityLevel": "Security Level",
    "securityLevelUpdatedToReserved": "Security Level Updated to 'Reserved'",
    "securityUpdate": "Security Update",
    "securityUpdatedSuccessfully": "Security Updated Successfully",
    "select": "Select",
    "selectADate": "Select a Date",
    "selectADocumentType": "Select a Document Type",
    "selectAnItem": "Select an Item",
    "selectContact": "Select Contact",
    "selectDocuments": "Select Documents",
    "selectFiles": "Select Files",
    "sendingDocuments": "Sending Documents",
    "sendSurveyDevice": "Send Survey to Device",
    "sendSurveyEmail": "Send Survey to Email",
    "serie": "Series",
    "seriePertenencia": "Series Belonging",
    "series-TRD": "Series - TRD",
    "seriesCode": "Series Code",
    "seriesItBelongsTo": "Series It Belongs To",
    "seriesStoredSuccessfully": "Series Stored Successfully",
    "serverCommunicationError": "Server Communication Error",
    "serviceAndSupportModule": "Service and Support Module",
    "setAsTheCurrentVersion": "Set as the Current Version",
    "setTheVersion#VersionName#AsTheCurrentDocumentRetentionTableVersion": "Set the Version #VersionName# as the Current Document Retention Table Version",
    "setVersion": "Set Version",
    "sheetNumber": "Sheet Number",
    "sheets": "Sheets",
    "sheetsInShipment": "Sheets in Shipment",
    "shelf_Estante": "Shelf",
    "shelf": "Shelf",
    "shiftTemplate": "Shift Template",
    "shipmentCanceled": "Shipment Canceled",
    "shippingAssignment": "Shipping Assignment",
    "shippingAssignmentCompletedSuccessfully": "Shipping Assignment Completed Successfully",
    "shippingGuide": "Shipping Guide",
    "shippingMethod": "Shipping Method",
    "shippingMethods": "Shipping Methods",
    "shippingMethodSavedSuccessfully": "Shipping Method Stored Successfully",
    "shippingZone": "Shipping Zone",
    "showAll": "Show All",
    "showIndex": "Show Index",
    "dataTablePaginationMessage": "Showing {{start}} to {{lastItem}} of {{totalRecords}}",
    "side": "Side",
    "sign": "Sign",
    "signatureConfiguration": "Signature Configuration",
    "signatureConfigurationSavedSuccessfully": "Signature Configuration Saved Successfully",
    "signatureType": "Signature Type",
    "signDocument": "Sign Document",
    "simpleSeries": "Simple Series",
    "simulate": "Simulate",
    "sites": "Sites",
    "size": "Size",
    "south": "South",
    "southeast": "Southeast",
    "specificTerms": "Specific Terms",
    "specifyTheCustomComponentOfProcesoXToBeRenderedWhenSelectingTheProcedure": "Specify the Custom Component of ProcesoX to be Rendered When Selecting the Procedure",
    "specifyTheDataAccessFunction": "Specify the Data Access Function",
    "specifyTheUserToAssignTheFirstTaskOfTheProcess": "Specify the User to Assign the First Task of the Process",
    "start": "Start",
    "startDate": "Start Date",
    "startDateOfRecordCreation": "Start Date of Record Creation",
    "startDocumentProcess": "Start Document Process",
    "status": "Status",
    "sticker": "Sticker",
    "stopServiceAndClearConfiguration": "Stop Service and Clear Configuration",
    "stopServices": "Stop Services",
    "storage": "Storage",
    "storageRecord": "Storage Record",
    "structure": "Structure",
    "subfondo": "Subfund",
    "subfund": "Subfund",
    "subject": "Subject",
    "subscription": "Subscription",
    "subscriptions": "Subscriptions",
    "subscriptionUpdated": "Subscription Updated",
    "subseccion": "Subsection",
    "subsection": "Subsection",
    "subserie": "Subseries",
    "subseriesCode": "Subseries Code",
    "subseriesStoredSuccessfully": "Subseries Stored Successfully",
    "surveys": "Surveys",
    "synchronizeDataAAD": "Synchronize Data AAD",
    "systemFile": "System File",
    "tableUpdatedSuccessfully": "Table Updated Successfully",
    "tacitWaiver": "Tacit Waiver",
    "targetVariable": "Target Variable",
    "tasks": "Tasks",
    "taskType": "Task Type",
    "taskTypes": "Task Types",
    "template": "Template",
    "templateGenerated": "Template Generated",
    "templates": "Templates",
    "terminologicalBank": "Terminological Bank",
    "terminologyBankStoredSuccessfully": "Terminological Bank Stored Successfully",
    "text": "Text",
    "theApprovalRequestHasBeenCompletedSuccessfully": "The Approval Request Has Been Completed Successfully",
    "theApprovalRequestHasBeenRejectedSuccessfully": "The Approval Request Has Been Rejected Successfully",
    "theCityWasSavedSuccessfully": "The City Was Saved Successfully",
    "theCountryWasSavedSuccessfully": "The Country Was Saved Successfully",
    "theCreationOfTheIncomingFileHasNotBeenCompletedYet.AreYouSureYouWantToDeleteIt": "The creation of the incoming file has not been completed yet. Are you sure you want to delete it?",
    "theCurrentIncomingFileHasNoLinkedFiles": "The current incoming file has no linked files",
    "theCurrentUserDoesNotHavePermissionToViewThePackagingRequest": "The current user does not have permission to view the packaging request",
    "theDepartmentWasSavedSuccessfully": "The department was saved successfully",
    "theDocumentCannotBeDeletedBecauseItIsLinkedToAnotherRecord": "The document cannot be deleted because it is linked to another record",
    "theDocumentRetentionTableVersionIsInactive": "The document retention table version is inactive",
    "theDocumentRetentionTableVersionWasNotFound.Version": "#version number#",
    "theFollowingDataOfTheReturnReasonWereUpdated": "The following data of the return reason were updated from 'No' to 'Yes'",
    "theFollowingPrerequisitesAreRequired": "The following prerequisites are required",
    "theIdTablaRetencionDocumentalParameterDoesNotHaveAValidValue(0)": "The idTablaRetencionDocumental parameter does not have a valid value (0)",
    "theIncomingFilesCannotBeLinkedBecauseTheMainIncomingFileIsNotInThe'InProgress'State": "The incoming files cannot be linked because the main incoming file is not in the 'In Progress' state",
    "theIncomingRecordHasBeenLinkedToTheInitialRequestNumber#RecordNumber#WithTheFollowingComment": "",
    "theInternalCommunicationCannotBeReassignedBecauseTheDestinationUserIsTheSameAsTheCurrentUser": "The internal communication cannot be reassigned because the destination user is the same as the current user",
    "theOutgoingFileHasNoAssociatedApprovalRequests": "The outgoing file has no associated approval requests",
    "theOutgoingFileHasNoAssociatedInformationRequests": "The outgoing file has no associated information requests",
    "thePermission'ReadAllDocumentTypes'WasGrantedToSection#SECTION#__": "#USER# has consulted the record",
    "thePermission'ReadAllDocumentTypes'WasGrantedToSection#SECTION#": "The permission 'Read all document types' was granted to section #SECTION#",
    "thePermissionFromSection#SECTION#WasRemovedFromTheRecord": "The permission from section #SECTION# was removed from the record",
    "thePersonIdentifiesAs": "The person identifies as",
    "theProfileWasSavedSuccessfully": "The profile was saved successfully",
    "theRecordCannotBeDeletedBecauseItHasAssociatedRecords": "The record cannot be deleted because it has associated records",
    "theRecordIsClosed,AndTheCreation,Editing,OrDeletionOfDocumentsIsNotAllowed": "The record is closed, and the creation, editing, or deletion of documents is not allowed",
    "theRecordNameWasChangedSuccessfully": "The record name was changed successfully",
    "theRecordWasClosed.Observations": "",
    "theRecordWasIncludedInFileNo": "The record was included in file No.",
    "theRecordWasLocked.Observations": "",
    "theRecordWasRenamedFrom#RECORDNAME#To#RECORDNAME#": "The record was renamed from #RECORDNAME# to #RECORDNAME#",
    "theRequestToMoveTheDocumentsWasCreatedSuccessfully": "The request to move the documents was created successfully",
    "theResponsibleOfTheRecordWasChangedFrom#USER#To#USER#.Observations": "",
    "theReturnReasonCannotBeDeletedAsItHasDependencies": "The return reason cannot be deleted as it has dependencies",
    "theReturnReasonWithTheName'reasonName'WasCreated": "The return reason with the name 'reason name' was created",
    "theSecurityLevelHasBeenUpdatedTo'Classified": "The security level has been updated to 'Classified'",
    "theSecurityLevelHasBeenUpdatedTo'Public": "The security level has been updated to 'Public'",
    "theSecurityOfTheRecordWasUpdatedToNotInheritPermissionsFromTheRetentionTable": "The security of the record was updated to not inherit permissions from the retention table",
    "theSigningUserCannotBeInTheMainRecipientsList": "The signing user cannot be in the main recipients list",
    "theTimeZoneIsMandatory": "The time zone is mandatory",
    "theURLForTheTramitexIncomingMailReportHasNotBeenConfigured.PleaseContactTheSystemAdministratorToUpdateTheSubscriptionParameters": "The URL for the Tramitex incoming mail report has not been configured. Please contact the system administrator to update the subscription parameters",
    "theUserUSERNAMEIsAlreadyIncludedAmongTheRecipientsOfTheInternalCommunication": "The user USERNAME is already included among the recipients of the internal communication",
    "theUserWasSavedSuccessfully": "The user was saved successfully",
    "theUserWasSuccessfullyAssociatedWithTheSection": "The user was successfully associated with the section",
    "thirdCall": "Third call",
    "thisCommunicationIsAssociatedAsAResponseToCommunication#communicationnumber#": "This communication is associated as a response to communication #communicationnumber#",
    "thisIncomingFileIsAssociatedAsAResponseToIncomingFile#incomingnumber#": "This incoming file is associated as a response to incoming file #incomingnumber#",
    "time": "Time",
    "timeUnit": "Time Unit",
    "timeZone": "Time Zone",
    "tipoRadicado": "Type of incoming file",
    "title": "Title",
    "to": "To",
    "toBack": "Back",
    "top-levelClassification": "Top-level Classification",
    "topic": "Topic",
    "topicScope": "Topic Scope",
    "tramite": "Procedure",
    "transferDate": "Transfer Date",
    "transfers": "Transfers",
    "transferSchedule": "Transfer Schedule",
    "transmissionDate": "Transmission Date",
    "tRDCode": "TRD Code",
    "tRDDocumentTypes": "TRD Document Types",
    "tRDSubseries": "TRD Subseries",
    "tRDVersion": "TRD Version",
    "type": "Type",
    "typeOfIdentification": "Type of Identification",
    "typeOfShipment": "Type of Shipment",
    "uniqueDocumentInventoryFormat(FUID)": "Unique Document Inventory Format (FUID)",
    "unlockRecord": "Unlock Record",
    "update": "Update",
    "updateContactType": "Update Contact Type",
    "updateDocumentRetentionTable": "Update Document Retention Table",
    "updateFromExcel": "Update from Excel",
    "updateSection": "Update Section",
    "updateTheRecord'sSecuritySoItDoesn'tInheritPermissionsFromTheRetentionTable": "Update the record's security so it doesn't inherit permissions from the retention table",
    "uploadDate": "Upload Date",
    "uploadDocument": "Upload Document",
    "uploadScannedDocuments": "Upload Scanned Documents",
    "uploadVoucher": "Upload Voucher",
    "uRI": "URI",
    "user": "User",
    "user#USER#HasViewedTheRecord": "User #USER# has viewed the record",
    "userInterface": "User Interface",
    "userPreferences": "User Preferences",
    "users": "Users",
    "userSuccessfullyDeleted": "User successfully deleted",
    "userTask-ProcessX": "User Task - ProcessX",
    "validatePostponingTheFileTransfer": "Validate postponing the file transfer",
    "value": "Value",
    "variable": "Variable",
    "variableName": "Variable Name",
    "variables": "Variables",
    "version": "Version",
    "versionCreatedSuccessfully": "Version created successfully",
    "versionGeneratedOn": "Version generated on",
    "versions": "Versions",
    "versionSuccessfullySetAsCurrent": "Version successfully set as current",
    "versionTRD": "TRD Version",
    "versionTVD": "TVD Version",
    "video": "Video",
    "view": "View",
    "viewAll": "View All",
    "viewDocument": "View Document",
    "viewElectronicHeadquartersButton": "View Electronic Headquarters Button",
    "viewFile": "View File",
    "viewRecord": "View Record",
    "visible": "Visible",
    "voBoRequestSentSuccessfully": "Approval Request Sent Successfully",
    "voucherUploadedSuccessfully": "Voucher Uploaded Successfully",
    "wasTheServiceProvidedInATimelyManner": "Was the service provided in a timely manner?",
    "webhooks": "WebHooks",
    "webRegistration": "Web Registration",
    "west": "West",
    "window": "Window",
    "withoutVoucher": "Without Voucher",
    "word": "Word",
    "year": "Year",
    "yes": "Yes",
    "youMustSelectAMetadata": "You must select a metadata",
    "youMustSelectSomeTypeOfNotificationEitherByEmailOrAtTheRegisteredAddress": "You must select some type of notification, either by email or at the registered address",
    "youResideIn": "You reside in",
    "zone": "Zone",
    "zoneSavedSuccessfully": "Zone Stored Successfully",
    darkMode: "Dark mode",
    english: "English",
    itemUpdatedSuccessfully: "Item updated successfully",
    language: "Ingles",
    languagePreference: "Language preference",
    logIn: "Login",
    previewFeatures: "Preview features",
    sigla: "Acronym",
    spanish: "Spanish",
    startScreenCapture: "Start screen capture",
    toUpdate: "Update",
    tutorials: "Tutorials",
    userPreferencesSavedSuccessfully: "User preferences saved"
};
